import React, { Component } from 'react';
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Chip,
  Button,
  TextField,
  InputAdornment,
} from '@mui/material';

// Ícones MUI
import StarIcon from '@mui/icons-material/Star';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import TuneIcon from '@mui/icons-material/Tune';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

export class AvaliacoesScreen extends Component {
  render() {
    return (
      <Box sx={{ minHeight: '100vh', p: 0, fontFamily: 'sans-serif' }}>

        {/* 1. Header & Breadcrumbs */}
        <Box mb={3}>
          <Breadcrumbs separator="/" aria-label="breadcrumb" sx={{ fontSize: '0.875rem', mb: 1 }}>
            <Link underline="hover" color="inherit" href="#">Início</Link>
            <Link underline="hover" color="inherit" href="#">Marketing</Link>
            <Typography color="text.secondary" fontSize="0.875rem">Avaliações</Typography>
          </Breadcrumbs>

          <Box display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                backgroundColor: '#FFF8E1',
                border: '1px solid #FFE082',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <StarIcon sx={{ color: '#FFB300', fontSize: 20 }} />
            </Box>
            <Typography variant="h4" fontWeight="bold" component="h1">
              Avaliações
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" mt={0.5}>
            Monitore a satisfação dos seus clientes e melhore a experiência.
          </Typography>
        </Box>

        {/* 2. Primeira Linha de Cards (Estatísticas Principais) */}
        <Grid container spacing={2.5} mb={2.5}>

          {/* Card 1: Nota Média */}
          <Grid item xs={12} md={4}>
            <Card variant="outlined" sx={{ borderRadius: 3, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CardContent sx={{ textAlign: 'center', py: 4 }}>
                <Box display="flex" alignItems="center" justifyContent="center" gap={1} mb={0.5}>
                  <StarIcon sx={{ color: '#FFB300', fontSize: 36 }} />
                  <Typography variant="h2" fontWeight="bold" component="span" sx={{ fontSize: '3rem', lineHeight: 1 }}>
                    0.0
                  </Typography>
                </Box>
                <Typography variant="subtitle1" fontWeight="600" color="text.primary">
                  Nota média
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Baseado em 0 avaliações
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Card 2: Distribuição */}
          <Grid item xs={12} md={4}>
            <Card variant="outlined" sx={{ borderRadius: 3, height: '100%' }}>
              <CardContent>
                <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ letterSpacing: 1, textTransform: 'uppercase' }}>
                  Distribuição
                </Typography>
                <Box mt={2} display="flex" flexDirection="column" gap={1.2}>
                  {[5, 4, 3, 2, 1].map((stars) => (
                    <Box key={stars} display="flex" alignItems="center" gap={1.5}>
                      <Box display="flex" alignItems="center" width={28}>
                        <Typography variant="body2" fontWeight="bold" sx={{ mr: 0.5 }}>
                          {stars}
                        </Typography>
                        <StarIcon sx={{ color: '#FFB300', fontSize: 16 }} />
                      </Box>
                      <Box flexGrow={1}>
                        <LinearProgress
                          variant="determinate"
                          value={0}
                          sx={{
                            height: 10,
                            borderRadius: 5,
                            backgroundColor: '#f0f0f0',
                            '& .MuiLinearProgress-bar': { backgroundColor: '#FFB300' },
                          }}
                        />
                      </Box>
                      <Typography variant="body2" color="text.secondary" width={16} textAlign="right">
                        0
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Card 3: Taxa de Satisfação */}
          <Grid item xs={12} md={4}>
            <Card variant="outlined" sx={{ borderRadius: 3, height: '100%' }}>
              <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
                <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ letterSpacing: 1, textTransform: 'uppercase' }}>
                  Taxa de Satisfação
                </Typography>

                {/* Satisfeitos */}
                <Box display="flex" alignItems="center" justifyContent="space-between" my={1.5}>
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#E8F5E9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <ThumbUpOutlinedIcon sx={{ color: '#2E7D32', fontSize: 20 }} />
                    </Box>
                    <Box>
                      <Typography variant="h5" fontWeight="bold" color="#2E7D32" sx={{ lineHeight: 1 }}>
                        0%
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Satisfeitos (4–5 estrelas)
                      </Typography>
                    </Box>
                  </Box>
                  <Typography variant="caption" color="text.secondary">0 clientes</Typography>
                </Box>

                <Box sx={{ borderBottom: '1px solid #f0f0f0', my: 1 }} />

                {/* Insatisfeitos */}
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#FFEBEE', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <ThumbDownOutlinedIcon sx={{ color: '#D32F2F', fontSize: 20 }} />
                    </Box>
                    <Box>
                      <Typography variant="h5" fontWeight="bold" color="#D32F2F" sx={{ lineHeight: 1 }}>
                        0%
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Insatisfeitos (1–2 estrelas)
                      </Typography>
                    </Box>
                  </Box>
                  <Typography variant="caption" color="text.secondary">0 clientes</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

        </Grid>

        {/* 3. Segunda Linha: Cards de Período */}
        <Grid container spacing={2.5} mb={2.5}>
          {[
            { title: 'Hoje', icon: <AccessTimeIcon sx={{ color: '#6A1B9A' }} /> },
            { title: 'Últimos 7 dias', icon: <TrendingUpIcon sx={{ color: '#6A1B9A' }} /> },
            { title: 'Últimos 30 dias', icon: <CalendarTodayIcon sx={{ color: '#6A1B9A' }} /> },
          ].map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card variant="outlined" sx={{ borderRadius: 3 }}>
                <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 2.5 }}>
                  <Box sx={{ width: 44, height: 44, borderRadius: '50%', bgcolor: '#F3E5F5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {item.icon}
                  </Box>
                  <Box>
                    <Typography variant="body2" color="text.secondary" fontWeight="500">
                      {item.title}
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      — <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 1 }}>0 avaliações</Typography>
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* 4. Banner de Configuração da Pesquisa */}


        {/* 5. Barra de Ações e Busca */}
        <Box display="flex" gap={2} flexWrap="wrap">
          <TextField
            placeholder="Pesquisar por nome ou comentário..."
            variant="outlined"
            size="small"
            sx={{
              flexGrow: 1,
              backgroundColor: '#fff',
              borderRadius: 2,
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />

          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            sx={{
              backgroundColor: '#fff',
              color: '#333',
              borderColor: '#e0e0e0',
              borderRadius: 2,
              textTransform: 'none',
              px: 2.5,
              '&:hover': { backgroundColor: '#f5f5f5', borderColor: '#d0d0d0' },
            }}
          >
            Filtros
          </Button>

          <Button
            variant="outlined"
            startIcon={<SearchIcon />}
            sx={{
              backgroundColor: '#fff',
              color: '#333',
              borderColor: '#e0e0e0',
              borderRadius: 2,
              textTransform: 'none',
              px: 2.5,
              '&:hover': { backgroundColor: '#f5f5f5', borderColor: '#d0d0d0' },
            }}
          >
            Pesquisa
          </Button>

          <Button
            variant="contained"
            startIcon={<FileDownloadOutlinedIcon />}
            sx={{
              backgroundColor: '#6A1B9A',
              color: '#fff',
              borderRadius: 2,
              textTransform: 'none',
              px: 2.5,
              '&:hover': { backgroundColor: '#4A148C' },
            }}
          >
            Exportar
          </Button>
        </Box>

      </Box>
    );
  }
}

export default AvaliacoesScreen;